import React from 'react';
import { FichaColumnas, FichaColumna } from './FichaColumnas.js';

const FichaGrilla = ({ items = [], columnaSeparada = -1 }) => {
  if (!items || items.length === 0) {
    return null;
  }

  const pivot =
    columnaSeparada >= 0 ? Math.min(columnaSeparada, items.length) : Math.ceil(items.length / 2);

  const itemsIzquierda = items.slice(0, pivot);
  const itemsDerecha = items.slice(pivot);

  return (
    <FichaColumnas>
      <FichaColumna width="48%" align="center">
        {itemsIzquierda.map((item) => (
          <div key={item.id} style={{ width: '100%' }}>
            {item.componente}
          </div>
        ))}
      </FichaColumna>

      {itemsDerecha.length > 0 && (
        <FichaColumna width="48%" align="center">
          {itemsDerecha.map((item) => (
            <div key={item.id} style={{ width: '100%' }}>
              {item.componente}
            </div>
          ))}
        </FichaColumna>
      )}
    </FichaColumnas>
  );
};

export default FichaGrilla;
